import { render, staticRenderFns } from "./electricwarning.vue?vue&type=template&id=64b01cd6&"
import script from "./electricwarning.vue?vue&type=script&lang=ts&"
export * from "./electricwarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports